import { Table } from "@mantine/core";

import { INCENTIVE_RULES } from "@/components/model/user/_type";
import { H2, Text } from "@/components/ui/elements";

type IncentiveTableProps = {
  data?: typeof INCENTIVE_RULES;
};

export function IncentiveTable({
  data = INCENTIVE_RULES,
}: IncentiveTableProps) {
  const incentiveRows = data.map((body, i) => (
    <Table.Tr key={i}>
      <Table.Td w={170} maw={170}>
        {body.applyTime}
      </Table.Td>
      <Table.Td>
        <Text c="blue" fw="bold" key={i} ta="center">
          {body.incentivePoint}
        </Text>
      </Table.Td>
    </Table.Tr>
  ));

  return (
    <>
      <H2>【加算ルール】</H2>
      <Table title="加算ポイント" withTableBorder withColumnBorders>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>条件</Table.Th>
            <Table.Th w={80} maw={80} ta="center">
              加算ポイント
            </Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>{incentiveRows}</Table.Tbody>
      </Table>
      <Text c="dimmed">
        ＊
        キャンセルまたは遅刻、早退をした場合は加算ポイントは付与されず、ペナルティポイントが適用されます。
      </Text>
    </>
  );
}
